import { ReactElement } from 'react';
import Action from './action';

interface IModalSingleton {
    onClose?: () => any,
    onCancel?: () => any,
    onSure?: () => any,
    title?: string,
    sureText?: string,
    cancelText?: string,
    showClose?: boolean,
    content?: string | ReactElement
    show?: boolean,
    extraClass?: string,
}

const initialState = {
    onClose: () => {},
    onCancel: () => {},
    onSure: () => {},
    title: '',
    content: '',
    sureText: '',
    cancelText: '',
    showClose: true,
    show: false,
    extraClass: ''
};

export default (state = initialState, action: {type: string, playload: IModalSingleton}) => {
    switch (action.type) {
        case Action.UPDATE_GLOBAL_MODAL: {
            // 每次先用initialState重置数据
            return {
                ...initialState,
                ...action.playload
            }
        }
        case Action.UPDATE_GLOBAL_MODAL_ONLY: {
            // 不重置数据
            return {
                ...state,
                ...action.playload
            }
        }
        default: return state;
    }
}
